import * as React from 'react';
import { Divider } from '@features/ui';
import { cn } from '@lib/utils.ts';
import { useLayoutEffect, useMemo, useRef, useState } from 'react';

function Textarea({
  className,
  hiddenHeader,
  ...props
}: React.ComponentProps<'textarea'> & { hiddenHeader?: boolean }) {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [isDisabled, setIsDisabled] = useState(false);

  useLayoutEffect(() => {
    if (inputRef.current) {
      setIsDisabled(inputRef.current.disabled);
    }
  }, []);

  const borderStyle = useMemo(() => {
    if (isDisabled || props.disabled) {
      return 'border-muted-foreground';
    }
    if (!hiddenHeader) {
      return 'min-h-16 border-input';
    }

    return 'border-[#C6C6C6]';
  }, [hiddenHeader, isDisabled, props.disabled]);

  return (
    <div
      className={cn(
        'flex-col border placeholder:text-muted-foreground focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 flex field-sizing-content w-full rounded-[3px] bg-transparent shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        borderStyle
      )}
    >
      {!hiddenHeader && <Divider className={'mt-9.5'} />}
      <textarea
        ref={inputRef}
        className={cn('px-3 py-2 text-xs', className)}
        data-slot="textarea"
        {...props}
      />
    </div>
  );
}

export { Textarea };
